import React from 'react';
import {Route, withRouter} from 'react-router-dom';

function Login(props) {
    const {component:Component, ...rest} = props;
    
    return (
      <Route {...rest}  render={()=>{
            return(
                <Component {...rest}  />
            )
        }} />
    );
}

export default withRouter(Login);